var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCopy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icon / 16px / Copy",
  stroke: "currentColor"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle 255",
  width: 8,
  height: 10,
  x: 3,
  y: 4,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle 256",
  d: "M10.5 12H12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v1.5"
}))));
export default SvgCopy;